// The course's tabs (courses/_hub_tabs) on a phone: six tabs overflow the
// strip, which scrolls sideways, and the page's own tab could sit off-screen
// as the one thing that says where the student is. This brings it into view.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside theme_toggle.js. CourseTabs.jsx does the same
// for the React strips.
//
// scrollLeft on the strip, never the element's own scroll-into-view: that
// scrolls every scrolling ancestor too, and would move the page on load.

export function revealCurrentTab(strip) {
  const current = strip.querySelector('[aria-current="page"]');
  if (!current || strip.scrollWidth <= strip.clientWidth) return;

  const left = current.offsetLeft - strip.offsetLeft;
  const right = left + current.offsetWidth;
  if (left < strip.scrollLeft || right > strip.scrollLeft + strip.clientWidth) {
    strip.scrollLeft = Math.max(0, left - 16);
  }
}

function revealAll() {
  document.querySelectorAll(".course-tabs").forEach(revealCurrentTab);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", revealAll);
} else {
  revealAll();
}
